import { useEffect, useState } from "react";
import { HashRouter, Outlet, Route, Routes } from "react-router-dom";
import WithNavigations from "./layouts/WithNavigations";
import { tokenStore } from "./shared/auth/tokenStore";
import { IAM_URL } from "./utils/constants";
import {
    HomePage,
    NotFound
} from "./pages";

function ProtectedRoute() {
    const [unauthenticated, setUnauthenticated] = useState(
        () => !tokenStore.get() || tokenStore.isExpired()
    );

    useEffect(() => {
        let expTimer: ReturnType<typeof setTimeout> | null = null;

        function scheduleExpiry() {
            if (expTimer !== null) clearTimeout(expTimer);
            const p = tokenStore.getParsed();
            const exp = p ? Number(p.exp) : NaN;
            if (!Number.isFinite(exp)) return;
            const remainingMs = exp * 1000 - Date.now();
            expTimer = setTimeout(() => setUnauthenticated(true), Math.max(0, remainingMs));
        }

        const unsubscribe = tokenStore.subscribe((token) => {
            setUnauthenticated(!token || tokenStore.isExpired());
            scheduleExpiry();
        });

        scheduleExpiry();

        return () => {
            unsubscribe();
            if (expTimer !== null) clearTimeout(expTimer);
        };
    }, []);

    useEffect(() => {
        if (unauthenticated) {
            window.location.href = `${IAM_URL}/#/logout`;
        }
    }, [unauthenticated]);

    if (unauthenticated) return null;

    return <Outlet />;
}

const AppRoutes = () => (
    <HashRouter>
        <Routes>
            <Route element={<ProtectedRoute />}>
                <Route path="/" element={<WithNavigations />} >
                    <Route index element={<HomePage />} />
                </Route>
            </Route>
            <Route path='*' element={<NotFound />} />
        </Routes>
    </HashRouter>
)

export default AppRoutes;
